import React from 'react';
import { HeadingMedium } from '@ajat/design-system/Configurator';
import DynamicAttributeControls from '../../Common/Product/DynamicAttributeControls';

/**
 * CLS-SE add-ons block ("Tillägg").
 *
 * Only the BE-driven dynamic attributes (non-color, non-size) are rendered here;
 * everything shown comes from product Attributes. Revealed once a size is picked.
 */
const CLSAddons = ({
  visible,
  dynamicAttributes = [],
  selectedAttributes = {},
  onAttributeChange,
  onInfoOpen,
  disabledValueIdsByAttribute = {},
  hiddenControlSlugs = new Set(),
  showRequiredErrors = false,
  requiredEmptySlugs = new Set(),
  requiredErrorText = 'Fyll i detta fält',
}) => {
  if (!visible) return null;

  const hiddenSet = hiddenControlSlugs instanceof Set ? hiddenControlSlugs : new Set(hiddenControlSlugs || []);
  const dynamicItems = (dynamicAttributes || []).filter(
    (a) => a.slug !== 'color' && a.slug !== 'size' && a.type !== 'color' && !hiddenSet.has(a.slug),
  );
  if (dynamicItems.length === 0) return null;

  return (
    <div className="pp__addons-reveal">
      <HeadingMedium title="Tillägg" />

      <DynamicAttributeControls
        attributes={dynamicItems}
        selectedAttributes={selectedAttributes}
        onAttributeChange={onAttributeChange}
        onInfoOpen={onInfoOpen}
        disabledValueIdsByAttribute={disabledValueIdsByAttribute}
        hiddenControlSlugs={hiddenSet}
        textfieldErrorText="Texten är för lång eller innehåller ogiltiga tecken"
        showRequiredErrors={showRequiredErrors}
        requiredEmptySlugs={requiredEmptySlugs}
        requiredErrorText={requiredErrorText}
        logoSideLabels={{ front: 'Framsida', back: 'Baksida' }}
      />
    </div>
  );
};

export default CLSAddons;
